<template>
  <div>
    <Filters @iut="filter = $event" @razonSocial="filter = $event"/>
    <TransactionalityDetail :filter="filter" />
  </div>
</template>

<script>
import Filters from '@/febos/global/operations/components/transactionality/Filters';
import TransactionalityDetail from '@/febos/global/operations/components/transactionality/TransactionalityDetail';

export default {
  name: 'Transactionality',
  components: {
    TransactionalityDetail,
    Filters
  },
  data() {
    return {
      filter: null
    };
  }
};
</script>

<style>

</style>
